import { z } from 'zod';
export const UpdateIntervalLabels: Record<number, string> = {
	41: '1 minute',
	51: '5 minutes'
};

export const updateDeviceSendingIntervalSchema = z.object({
	updateManifestId: z.string({ message: 'Sending interval is required' }).nonempty('Sending interval is required')
});

export type UpdateDeviceSendingIntervalSchema = z.infer<typeof updateDeviceSendingIntervalSchema>;
